import { createSetting, VALUE_TYPE_BOOLEAN } from './setting';

export default {
  remuneracaoBase: createSetting('Remuneração Base', VALUE_TYPE_BOOLEAN, true),
  alimentacao: createSetting('Alimentação', VALUE_TYPE_BOOLEAN, true),
  reembolso: createSetting('Reembolsos Diversos', VALUE_TYPE_BOOLEAN, true),
  // PI/DA Não é um campo editável
  // pida: createSetting('PI/DA', VALUE_TYPE_BOOLEAN, true),
  transporte: createSetting('Transporte', VALUE_TYPE_BOOLEAN, true),
  beneficios: createSetting('Cesta Benefícios', VALUE_TYPE_BOOLEAN, true),
  valorAdicional: createSetting('Valor Adicional', VALUE_TYPE_BOOLEAN, true),
  outrosDescontos: createSetting('Outros Descontos', VALUE_TYPE_BOOLEAN, true),
  refeicao: createSetting('Refeição', VALUE_TYPE_BOOLEAN, true),
  ajudaCusto: createSetting('Ajuda de Custo', VALUE_TYPE_BOOLEAN, true),
  premio: createSetting('Prêmio', VALUE_TYPE_BOOLEAN, true),
  dependentes: createSetting('Dependentes', VALUE_TYPE_BOOLEAN, true),
};
